<template>
  <div class="Purchase__Loading">
    <icon-loading />
    <span>loading your options</span>
  </div>
</template>

<script>
import IconLoading from './icons/IconLoading.vue'
export default {
  name: 'BwrLoading',
  components: { IconLoading },
}
</script>

<style>
.Purchase__Loading {
  line-height: 15px;
  font-size: 15px;
  color: var(--color-forest-60);
}

.Purchase__Loading .Icon--loading {
  vertical-align: bottom;
  width: 30px;
  height: 15px;
  position: relative;
  left: -4px;
}
</style>
